// components/shared/DateRangeFilter.jsx
// Drop-in filter bar — pass useDateFilter() return values as props.
import React, { useState } from "react";
import { PRESETS } from "../../hooks/useDateFilter";

export default function DateRangeFilter({
  preset, setPreset,
  customFrom, setCustomFrom,
  customTo,   setCustomTo,
  count, total, rangeLabel,
  style = {},
}) {
  const [showCustom, setShowCustom] = useState(preset === "custom");

  const handlePreset = (key) => {
    setPreset(key);
    setShowCustom(key === "custom");
  };

  const isFiltered = preset !== "all";

  return (
    <div style={{
      background: "#fff",
      border: "1px solid #E5E7EB",
      borderRadius: 14,
      padding: "12px 16px",
      display: "flex",
      flexDirection: "column",
      gap: 10,
      ...style,
    }}>
      {/* Top row: label + pill buttons */}
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        <span style={{ fontSize: 11, fontWeight: 700, color: "#6B7280", textTransform: "uppercase", letterSpacing: "0.07em", flexShrink: 0 }}>
          📅 Date Range
        </span>

        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", flex: 1 }}>
          {PRESETS.map(p => (
            <button
              key={p.key}
              onClick={() => handlePreset(p.key)}
              style={{
                padding: "5px 13px",
                borderRadius: 20,
                border: "1.5px solid",
                borderColor: preset === p.key ? "#0052CC" : "#E5E7EB",
                background: preset === p.key ? "#0052CC" : "#fff",
                color: preset === p.key ? "#fff" : "#374151",
                fontSize: 12,
                fontWeight: preset === p.key ? 700 : 500,
                cursor: "pointer",
                fontFamily: "inherit",
                transition: "all 0.15s",
                whiteSpace: "nowrap",
              }}
              onMouseEnter={e => {
                if (preset !== p.key) {
                  e.currentTarget.style.borderColor = "#0052CC";
                  e.currentTarget.style.color = "#0052CC";
                }
              }}
              onMouseLeave={e => {
                if (preset !== p.key) {
                  e.currentTarget.style.borderColor = "#E5E7EB";
                  e.currentTarget.style.color = "#374151";
                }
              }}
            >
              {p.icon} {p.label}
            </button>
          ))}
        </div>

        {/* Record count badge */}
        <div style={{
          display: "flex", alignItems: "center", gap: 6, flexShrink: 0,
          padding: "4px 12px", borderRadius: 20,
          background: isFiltered ? "#EBF3FF" : "#F3F4F6",
          border: `1px solid ${isFiltered ? "#C7E0FF" : "#E5E7EB"}`,
        }}>
          <span style={{ fontSize: 12, fontWeight: 700, color: isFiltered ? "#0052CC" : "#6B7280" }}>
            {count}
          </span>
          <span style={{ fontSize: 11, color: "#9CA3AF" }}>
            {isFiltered ? `of ${total} weeks` : "weeks"}
          </span>
        </div>
      </div>

      {/* Custom date range inputs */}
      {showCustom && (
        <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", paddingTop: 4 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <label style={{ fontSize: 11, color: "#6B7280", fontWeight: 600, whiteSpace: "nowrap" }}>From</label>
            <input
              type="date"
              value={customFrom}
              onChange={e => setCustomFrom(e.target.value)}
              style={dateInputStyle}
            />
          </div>
          <span style={{ color: "#D1D5DB", fontSize: 16 }}>→</span>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <label style={{ fontSize: 11, color: "#6B7280", fontWeight: 600, whiteSpace: "nowrap" }}>To</label>
            <input
              type="date"
              value={customTo}
              onChange={e => setCustomTo(e.target.value)}
              style={dateInputStyle}
            />
          </div>
          {(customFrom || customTo) && (
            <button
              onClick={() => { setCustomFrom(""); setCustomTo(""); }}
              style={{ fontSize: 11, color: "#EF4444", background: "none", border: "none", cursor: "pointer", fontFamily: "inherit", padding: 0 }}
            >
              ✕ Clear
            </button>
          )}
        </div>
      )}

      {/* Active filter summary */}
      {isFiltered && preset !== "custom" && (
        <div style={{ fontSize: 11, color: "#6B7280", display: "flex", alignItems: "center", gap: 4 }}>
          <span style={{ color: "#0052CC" }}>●</span>
          Showing <strong style={{ color: "#374151" }}>{rangeLabel}</strong>
          &nbsp;·&nbsp;
          <button
            onClick={() => handlePreset("all")}
            style={{ fontSize: 11, color: "#9CA3AF", background: "none", border: "none", cursor: "pointer", fontFamily: "inherit", padding: 0, textDecoration: "underline" }}
          >
            Clear filter
          </button>
        </div>
      )}
    </div>
  );
}

const dateInputStyle = {
  padding: "6px 10px",
  fontSize: 12,
  fontFamily: "inherit",
  border: "1.5px solid #D1D5DB",
  borderRadius: 8,
  outline: "none",
  color: "#111827",
  background: "#fff",
};